<template>
  <div class="style">
    <template v-if="projectInfo.myRoleInProject == Role.Client">
      <section class="start-quiz">
        <div>
          <h1 class="start-quiz__title">
            {{ $t("project_details.style_quiz.do_you_know_which_style") }}
          </h1>
          <p class="start-quiz__subtitle">
            {{ $t("project_details.style_quiz.choose_your_style") }}
          </p>
        </div>
        <div class="start-quiz__button-group">
          <button
            @click="emit('onStartDefinedStylesQuiz')"
            class="quiz-button quiz-button-outline"
          >
            {{ $t("project_details.style_quiz.know_my_style") }}
          </button>
          <button @click="emit('onStartQuiz')" class="quiz-button">
            {{ $t("project_details.style_quiz.want_to_style_quiz") }}
          </button>
        </div>
      </section>
    </template>
  </div>
</template>

<script setup>
import { Role } from "@/helpsers/role.helper";
import { useAuthStore } from "@/stores/auth.store";

const auth = useAuthStore();
const props = defineProps({
  projectInfo: { type: Object, default: {} },
});
const emit = defineEmits(["onStartQuiz", "onStartDefinedStylesQuiz"]);
</script>

<style lang="scss" scoped>
@use "@/css/quiz";

.style {
  &__product {
    overflow: auto;
  }

  &__item {
    &-image {
      background-size: cover;
    }
  }
}

.start-quiz {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 60px;
  text-align: center;
  padding-top: 30px;
  &__title {
    font-weight: 600;
    font-size: 2.75rem;
    line-height: 6rem;
  }
  &__subtitle {
    font-weight: 500;
    font-size: 1.75rem;
    line-height: 2.125rem;
    color: #767a80;
  }
  &__button-group {
    display: flex;
    gap: 2rem;
    flex-direction: column;
    @media screen and (min-width: 850px) {
      flex-direction: row;
    }
  }
}
</style>
